import { motion, useReducedMotion, type Variants } from 'motion/react';
import { Logo } from '@/components/logo';

// Shares the CTA button's spring feel (see cta-button.tsx) without the
// deck/pill treatment — a raised chip would turn the wordmark into a
// button-like element, which reads as too heavy for a plain nav logo.
const pressTransition = {
  type: 'spring',
  stiffness: 620,
  damping: 32,
  mass: 0.5,
} as const;

const logoVariants: Variants = {
  rest: { y: 0, scale: 1 },
  hover: { y: -2, scale: 1.02 },
  tap: { y: 1, scale: 0.97 },
};

/** Wordmark with lift-on-hover / press-on-tap motion, no background or deck. */
export function AnimatedLogo({ className }: { className?: string }) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.span
      initial="rest"
      animate="rest"
      whileHover={reduceMotion ? undefined : 'hover'}
      whileTap={reduceMotion ? undefined : 'tap'}
      variants={logoVariants}
      transition={pressTransition}
      className="inline-flex"
    >
      <Logo className={className} />
    </motion.span>
  );
}
